<template>
  <div class="border-t-2 border-red-900 py-4 px-4 md:px-6 shadow max-w-4xl">
    <doe-fieldset-heading class="mb-2" :label="label" :description="description" />
    <slot/>
    <doe-button class="mt-4" v-if="buttonLabel" :label="buttonLabel" appearance="primary" :action="action" @click="handleClick($event)" />
  </div>
</template>

<script>
import DoeFieldsetHeading from "@/components/typography/FieldsetHeading";
import DoeButton from "@/components/button/Button";

export default {
  name: "Banner",
  props: {
    label: {
      required: true
    },
    description: {
      required: false
    },
    buttonLabel: {
      required: false
    },
    action: {
      required: false
    }
  },
  components: {
    DoeFieldsetHeading,
    DoeButton
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="scss" scoped></style>